import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { parseDate, pdfDocEncodingDecode, PDFDocument } from "pdf-lib";
import * as pdfjsLib from "pdfjs-dist/build/pdf";




//  import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';

// Set worker fors pdf.js
//  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

const Temp2 = () => {
  const [file, setFile] = useState(null);
  const [newFileName, setNewFileName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [newpdf, setnewpdf] = useState(null);
  const [selectedName, setSelectedName] = useState("");
  const [newselectedName, setnewSelectedName] = useState("");
  const [newemployeecode, setnewemployeecode] = useState("");
  const [employeecode, setemployeecode] = useState("");
  const [namess, setnames] = useState("");
  const [newblob, setnewblob] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [disable, setdisable] = useState(false);
  const [pdfInfo, setPdfInfo] = useState([]);
  const [Submittingreverse, setIsSubmittingreverse] = useState(false);
  const [names, setNames] = useState([]);
  const iframeRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(1);
  const [pdfDoc, setPdfDoc] = useState(null);
  const canvasRef = useRef(null);
  const [responseData, setResponseData] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [pageNumbers, setPageNumbers] = useState(1);
  const [Khuid, setKhuid] = useState(null);
  const [pdfData, setPdfData] = useState({});
  const [employeeDocument, setEmployeeDocument] = useState(null);
  const [error, setError] = useState('');
  const [base64String, setBase64String] = useState('');
  const [isGridOpen, setIsGridOpen] = useState(false); 
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  // const [employeecode, setemployeecode] = useState("");
 
  const gridRef = useRef(null); 
  let pdfBlob;



  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close the grid if the click is outside the grid or input
      if (gridRef.current && !gridRef.current.contains(event.target)) {
        setIsGridOpen(false); // Close grid
      }
    };

    // Add event listener to detect outside clicks
    document.addEventListener("mousedown", handleClickOutside);
    
    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [gridRef]);

  // useEffect(() => {
  //   const fetchPdfData = async () => {
  //     if (employeeDocument) {
  //       const data = {};

    
  //       for (const doc of employeeDocument) {
  //         const { DocumentTypeName, Attachment } = doc;

  //         if (DocumentTypeName && Attachment) {
  //           // Construct the API URL with the attachment name
  //           const apiUrl = `https://service.khexports.in/api/Common/GetImageURL?bucketName=one-erp-live&fileName=GD/EmployeeDocument/${Attachment}`;

  //           try {
  //             // Fetch the image URL from the API
  //             const response = await axios.get(apiUrl);
  //           //  console.log(response)
  //             const Pdfurls = (response.data.ImageURL); 

  //             console.log(Pdfurls);
             
  //             // const base=await convertPDFLinkToBlob(response.data.ImageURL);
  //             //  await downloadPDF(Pdfurls);
  //             // console.log(base);
  //             // const base64=await convertPdfToBase64(Pdfurls);
  //             // const blob=await fetchPdfAsBlob(Pdfurls);
  //             // console.log(blob);

              
  //             // Fetch the image data (convert URL to blob)
  //              const imageResponse = await axios.get(Pdfurls, { responseType: 'blob' });
             
  //             // const imageResponse = await convertPdfToBase64(Pdfurls);
  //             console.log(imageResponse);

  //             const base64Data = await convertBlobToBase64(imageResponse.data);
  //             const base64String = base64Data.split(',')[1];
  //             console.log(base64String);


  //             const addKeyValuePair = (DocumentTypeName, base64String) => {
  //               setPdfData(prevState => ({
  //                 ...prevState,   // Spread the existing pdfData
  //                 [DocumentTypeName]: base64String    // Add the new key-value pair
  //               }));
  //             };

  //             addKeyValuePair(DocumentTypeName, base64String);
  //             // Store the documentTypeName as the key and the base64 string as the value
  //             // data[DocumentTypeName] = base64Data;
  //             // Store the documentTypeName as the key and the Blob as the value
  //           // Blob data
  //           } catch (error) {
  //             console.error(`Failed to fetch attachment for ${DocumentTypeName}:`, error);
  //           }
  //         }
  //       }

       
  //       // setPdfData(data);
  //     }
  //   };

  //   fetchPdfData();
  // }, [employeeDocument]);



  
    // Create an async function to fetch the data
    // const fetchEmployeeDocument = async () => {
    //   const requestData = {
    //     pFactoryID: '2',
    //     pLoggedInUserID: '49',
    //     pEmployeeNo: '13077'
    //   };

    //   try {
    //     // Make the POST request using Axios
    //     const response = await axios.post('https://service.khexports.in/api/EmployeeDocument/GetEmployeeDocumentInfo', requestData);
    //     const parsedData = JSON.parse(response.data.Data);
    //     // Set the data in state
    //     setEmployeeDocument(parsedData);
    //    console.log(employeeDocument);
    //   } catch (error) {
    //     // Handle error case
    //     setError('Failed to fetch employee document info');
    //     console.error('Error:', error);
    //   } finally {
    //     // Stop the loading spinner
    //     setLoading(false);
    //   }
    // };


    // const fetchEmployeeDocument = async (employeeCode) => { // receive employeeCode
    //   const requestData = {
    //     pFactoryID: '2',
    //     pLoggedInUserID: '49',
    //     pEmployeeNo: employeeCode  // use the passed employeeCode
    //   };
    
    //   try {
    //     // Make the POST request using Axios
    //     const response = await axios.post('https://service.khexports.in/api/EmployeeDocument/GetEmployeeDocumentInfo', requestData);
    //     const parsedData = JSON.parse(response.data.Data);

    //     // if(!parsedData || !parsedData.data){
    //     //   setPdfData({});
    //     //   return;
    //     // }
    //     // Set the data in state
    //     setEmployeeDocument(parsedData);
    //     // setemployeecode("");
    //     console.log(employeeDocument);
    //   } catch (error) {
    //     // Handle error case
    //     setError('Failed to fetch employee document info');
    //     console.error('Error:', error);
        
    //   } finally {
    //     // Stop the loading spinner
    //     setLoading(false);
    //     // setemployeecode("");
    //   }
    // };

 
    const fetchEmployeeDocument = async (employeeCode) => { 

      const data = [
        { factoryid: 4, subdivision: 1, factoryname: "FWD" },
        { factoryid: 2, subdivision: 2, factoryname: "GD" },
        { factoryid: 3, subdivision: 22, factoryname: "TAD" },
        { factoryid: 7, subdivision: 17, factoryname: "RF" },
        { factoryid: 5, subdivision: 4, factoryname: "LGD" },
        { factoryid: 5, subdivision: 20, factoryname: "LGD" ,subcat:"LPD"},
        { factoryid: 5, subdivision: 23, factoryname: "LGD" ,subcat:"unit3"},
        { factoryid: 5, subdivision: 24, factoryname: "LGD",subcat:"unit4" },
        // { factoryid: 5, subdivision: 6, factoryname: "RAB" },
      ];
  
      const storedResponse = JSON.parse(sessionStorage.getItem("response"));
      const factoryID = storedResponse?.FactoryID;
      const SubDivisionID= storedResponse?.SubDivisionID;
      const factoryData = data.find(item => item.subdivision === SubDivisionID);
      console.log(factoryData.factoryname);
     

      const requestData = {
        pFactoryID: storedResponse.FactoryID,
        pLoggedInUserID: storedResponse.UserID,
        pEmployeeNo: employeeCode
      };
    
      try {
        // Make the POST request using Axios
        // const response = await axios.post('https://service.khexports.in/api/EmployeeDocument/GetEmployeeDocumentInfo', requestData);
        // console.log(response)
        // const parsedData = JSON.parse(response.data.Data);
        // console.log(parseDate);
        // Set the employee document in state
        // setEmployeeDocument(parsedData);
    
        // Call fetchPdfData after setting the document
       // fetchPdfData(parsedData);
       const response = await axios.post('https://service.khexports.in/api/EmployeeDocument/GetEmployeeDocumentInfo', requestData);

       // Log the entire response to inspect the structure
       console.log(response);
       
       // Check if response.data and response.data.Data exist and are not an empty array
       if (response.data && response.data.Data) {
           if (Array.isArray(response.data.Data) && response.data.Data.length === 0) {
               console.log('No data available in response.data.Data (empty array)');
               setPdfData({});
               setEmployeeDocument(null);
               setPdfUrl(null);
               setnewblob(null);
               setnewpdf(null);
               setSelectedName("");
               setnewSelectedName("");
               setnames("");
               setFile(null);
               setdisable(false);
             
           } else {
               try {
                   // Assuming response.data.Data is JSON and not already an array
                   const parsedData = typeof response.data.Data === 'string' ? JSON.parse(response.data.Data) : response.data.Data;
                   console.log(parsedData);
                   setEmployeeDocument(parsedData);  // Log parsed data
                   setPdfData({});
                   setPdfUrl(null);
                   setnewblob(null);
                   setnewpdf(null);
                   setSelectedName("");
                   setnewSelectedName("");
                   setnames("");
                   setFile("");
                   setdisable(false);
                
                  await fetchPdfData(parsedData);
      
               } catch (error) {
                   console.error('Error parsing JSON:', error);
               }
           }
       } else {
           console.log('No data available in response');
       }
       

      
        // If data exists, call fetchPdfData with parsedData
       
      } catch (error) {
        // Handle error case
        setError('Failed to fetch employee document info');
        console.error('Error:', error);
       
      } finally {
        // Stop the loading spinner
        setLoading(false);
      }
    };

    // const fetchPdfData = async (employeeDocument) => {
    //   if (employeeDocument) {
    //     for (const doc of employeeDocument) {
    //       const { DocumentTypeName, Attachment } = doc;
    
    //       if (DocumentTypeName && Attachment) {
    //         // Construct the API URL with the attachment name
    //         const apiUrl = `https://service.khexports.in/api/Common/GetImageURL?bucketName=one-erp-live&fileName=GD/EmployeeDocument/${Attachment}`;
    
    //         try {
    //           // Fetch the image URL from the API
    //           const response = await axios.get(apiUrl);
    //           const Pdfurls = response.data.ImageURL;
    
    //           // Fetch the PDF data (convert URL to blob)
    //           const imageResponse = await axios.get(Pdfurls, { responseType: 'blob' });
    //           const base64Data = await convertBlobToBase64(imageResponse.data);
    //           const base64String = base64Data.split(',')[1];
    //           console.log(base64String);
    
    //           // Store the documentTypeName as the key and the base64 string as the value
    //           setPdfData(prevState => ({
    //             ...prevState, // Spread the existing pdfData
    //             [DocumentTypeName]: base64String // Add the new key-value pair
    //           }));
    
    //         } catch (error) {
    //           console.error(`Failed to fetch attachment for ${DocumentTypeName}:`, error);
    //         }
    //       }
    //     }
    //   }
    // };
    const data = [
      { factoryid: 4, subdivision: 1, factoryname: "FWD" },
      { factoryid: 2, subdivision: 2, factoryname: "GD" },
      { factoryid: 3, subdivision: 22, factoryname: "TAD" },
      { factoryid: 7, subdivision: 17, factoryname: "RF" },
      { factoryid: 5, subdivision: 4, factoryname: "LGD" },
      { factoryid: 5, subdivision: 20, factoryname: "LGD" ,subcat:"LPD"},
      { factoryid: 5, subdivision: 23, factoryname: "LGD" ,subcat:"unit3"},
      { factoryid: 5, subdivision: 24, factoryname: "LGD",subcat:"unit4" },
      // { factoryid: 5, subdivision: 6, factoryname: "RAB" },
    ];

    
    const fetchPdfData = async (employeeDocument) => {
      const storedResponse = JSON.parse(sessionStorage.getItem("response"));
      const factoryID = storedResponse?.FactoryID;
      const SubDivisionID= storedResponse?.SubDivisionID;
      const factoryData = data.find(item => item.subdivision === SubDivisionID);
      if (employeeDocument) {
        const fetchPromises = employeeDocument.map(async (doc) => {
          const { DocumentTypeName, Attachment } = doc;
          setLoading(true);
         
          if (DocumentTypeName && Attachment) {
            const encodedAttachment = encodeURIComponent(Attachment)
            const apiUrl = `https://service.khexports.in/api/Common/GetImageURL?bucketName=one-erp-live&fileName=${factoryData.factoryname}/EmployeeDocument/${encodedAttachment}`;
            try {
              console.log(Attachment);
              const response = await axios.get(apiUrl);
              const Pdfurls = response.data.ImageURL;
              console.log(Pdfurls);
              const imageResponse = await axios.get(Pdfurls, { responseType: 'blob' });
              const base64Data = await convertBlobToBase64(imageResponse.data);
              const base64String = base64Data.split(',')[1];
              return { DocumentTypeName, base64String }; // Return key-value pair for later use
            } catch (error) {
              console.error(`Failed to fetch attachment for ${DocumentTypeName}:`, error);
            }
          }
        });
  
        // Wait for all fetch operations to complete
        const results = await Promise.all(fetchPromises);
        // if(!results){
        //     setPdfData({});
        // }
        
        // Filter out undefined results
        const validResults = results.filter(result => result);
        // if(!pdfData){
            validResults.forEach(({ DocumentTypeName, base64String }) => {
                setPdfData(prevState => ({
                  ...prevState,
                  [DocumentTypeName]: base64String,
                }));
              });
        setLoading(false);
        console.log(pdfData)
        // Update the state with the new pdf data
        
      }
    };
  
    

  useEffect(() => {
    // Function to load PDF keys and page count
    const loadPdfInfo = async () => {
      const info = await Promise.all(
        Object.keys(pdfData).map(async (key) => {
          const base64 = pdfData[key];
          const numPages = await getPdfPageCount(base64);
          return { name: key, pages: numPages };
        })
      );
      setPdfInfo(info);
    };

    if (pdfData) {
      loadPdfInfo();
    }
  }, [pdfData]);

//   useEffect(() => {
//     const loadPdf = async () => {
//       if (pdfUrl) {
//         try {
//           const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
//           setPdfDoc(pdf);
//           setPageNumbers(1); // Reset to the first page
//           renderPage(1); // Render the first page
//         } catch (error) {
//           console.error("Error loading PDF:", error);
//         }
//       }
//     };

//     loadPdf();
//   }, [pdfUrl]);

const [referenceDetails, setReferenceDetails] = useState([]);
const [referenceDetailscode, setReferenceDetailscode] = useState([]);


  useEffect(() => {
    // Fetch the API data using axios
    axios
      .get(
        "https://service.khexports.in/api/SReferenceDetails/GetSReferenceDetailsList?pFactoryID=MQ==&pReferenceTypeCode=RURU&pLoggedInUserID=NDk="
        
      )
      .then((response) => {
        // Map over the response data to extract only ReferenceDetailsName
        const referenceNames = response.data.map(
          (item) => item.ReferenceDetailsName
        );

        setNames(referenceNames); // Set the names in state

        const detailss = response.data.map((item) => ({
          ReferenceDetailsName: item.ReferenceDetailsName,
          ReferenceDetailsCode: item.ReferenceDetailsCode,
        }));

        setReferenceDetailscode(detailss);

console.log(referenceDetailscode)

        const details = response.data.map((item) => ({
          DocumentTypeName: item.ReferenceDetailsName,
          DocumentTypeID: item.ReferenceDetailsID,
        }));
        setReferenceDetails(details);
        console.log("this is ref",referenceDetails);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      const storedResponse = JSON.parse(sessionStorage.getItem("response"));
      const factoryID = storedResponse?.FactoryID;
      const userID = storedResponse?.UserID;
      const SubDivisionID= storedResponse?.SubDivisionID; // Assuming userID comes from sessionStorage
      console.log(userID);
      const body = {
        pListCategory: "E",
        pFactoryID: factoryID,
        pLoggedInUserID: userID,
        pSubDivisionID: SubDivisionID,
        pPageIndex: 1,
        pPageSize: 10000,
        pSearchString: "",
        pWhereString: "AND A.LiveFlag='1'",
      };

      try {
        const response = await axios.post(
          "https://service.khexports.in/api/EmployeeMaster/GetEmployeeMasterListNew",
          body,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        
        const parsedData = JSON.parse(response.data.Data);
        console.log(parsedData);
        setEmployees(parsedData); // Set the parsed data in state
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    fetchEmployeeData();
  }, []);

//   useEffect(() => {
//     console.log("this this employee data ",employees);
//     console.log(employeeDocument);
//   }, []);

  // Step 2: Function to handle when an employee is clicked
  const handleEmployeeClick = async(employeeCode, employeeName, khuid) => {
    // Concatenate EmployeeCode and EmployeeName and set to the state
    setSelectedEmployee(`${employeeCode} - ${employeeName}`);
    console.log(employeeCode);
    // setemployeecode(employeeCode);
    setnewemployeecode(employeeCode);
    setKhuid(khuid)  ;
    await fetchEmployeeDocument(employeeCode);  // Call the function to fetch the employee document
    setIsGridOpen(false);
  };

  function convertBlobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result); // This will return the base64 string
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob); // Read the blob as a Data URL (base64)
    });
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  const base64ToBlob = (base64, contentType) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };
  
  const base64ToBlobs = (base64, type = "application/pdf") => {
    const binary = atob(base64);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type });
  };

  //      const sendFilesToBackend = async (e) => {
  //          e.preventDefault();

  //         const formData = new FormData();
  //         // formData.append('employeeId', employeecode);
  //         // append('UploadFiles', pdfBlob, `${newFileName}.pdf`);
  //         formData.append('bucketName', 'one-erp-live');
  //         formData.append('storageMethod', 'S3');
  //         formData.append('subFolderName', 'EmployeeDocument');

  //         names.forEach((name) => {
  //             const storedData = pdfData[name];

  //             if (storedData) {
  //                 const employeeId = employeecode;
  //                 const blob = base64ToBlob(storedData, 'application/pdf');

  //                 formData.append('UploadFiles', blob, `${employeeId}_${name}.pdf`);

  //             } else {
  //                 console.log(`No data found for: ${name}`);
  //             }
  //         });

  //         try {

  //             const response = await axios.post('https://localhost:7016/api/common/saveAttachment', formData, {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data', // Important for file uploads
  //                 },
  //             });

  //             //https://service.khexports.in/api/common/saveAttachment

  //             console.log('Successfully uploaded all files:', response.data);
  //             alert(response.data)
  //         } catch (error) {
  //             console.error('Error uploading files:', error.response ? error.response.data : error.message);
  //         }

  //         setPdfData({});
  //     };
  // const [employeecode, setEmployeeCode] = useState('');

  // const handleEmployeeCodeChange = (e) => {
  //   const code = e.target.value;
  //   setemployeecode(code);

  //   // Find the employee by EmployeeCode
  //   const employee = employees.find((emp) => emp.EmployeeCode === code);
  //   if (employee) {
  //     setKhuid(employee.KHUID);
  //     // Set the KHUID if the employee is found
  //   } else {
  //     setKhuid(null); // Reset KHUID if no employee found
  //   }
  //   console.log(Khuid);
  // };

  //07-10-24 const sendFilesToBackend = async (e) => {
  //   e.preventDefault();

  //   if (!Khuid) {
  //     alert("No employee found with the given Employee Code");
  //     return;
  //   }

  //   const formData = new FormData();

  //   names.forEach((name) => {
  //     const storedData = pdfData[name];

  //     if (storedData) {
  //       const blob = base64ToBlob(storedData, "application/pdf");
  //       formData.append("UploadFiles", blob, `${Khuid}_${name}.pdf`);
  //     } else {
  //       console.log(`No data found for: ${name}`);
  //     }
  //   });

  //   console.log(formData.entries());

  //   for (const [key, value] of formData.entries()) {
  //       // If the value is a Blob, you might want to display its name instead
  //       if (value instanceof Blob) {
  //         console.log(`${key}: ${value.name}`);
  //       } else {
  //         console.log(`${key}: ${value}`);
  //       }
  //     }

  //   try {
  //     const response = await axios.post("", formData, {
  //       params: {
  //         bucketName: "one-erp-live",
  //         storageMethod: "S3",
  //         subFolderName: "GD/EmployeeDocument",
  //       },
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     console.log("Successfully uploaded all files:", response.data);
  //     alert(response.data);
  //     setPdfData({});
  //   } catch (error) {
  //     console.error(
  //       "Error uploading files:",
  //       error.response ? error.response.data : error.message
  //     );
  //   }
  // };
//https://service.khexports.in/api/EmployeeDocument/InsertOrUpdateEmployeeDocumentPage
  const insertOrUpdateEmployeeDocument = async (fileDataArray) => {
    const storedResponse = JSON.parse(sessionStorage.getItem("response"));
    try {
      const response = await axios.post("https://service.khexports.in/api/EmployeeDocument/InsertOrUpdateEmployeeDocumentPage", {
        pFactoryID: storedResponse.FactoryID,
    pLoggedInUserID: storedResponse.UserID,
    pEmployeeDocumentSetups: fileDataArray, 
      }, {
        headers: {
          'Content-Type': 'application/json', // Adjust headers if necessary
        },
      });
  
      // Handle the successful response
      console.log('Response data:', response.data);
      return response.data;
  
    } catch (error) {
      // Handle errors here
      console.error('Error sending the request:', error);
      throw error;
    }
  };
  
  const [showToast, setShowToast] = useState(false);
  const sendFilesToBackend = async (e) => {
    e.preventDefault();
  
    if (!Khuid) {
      alert("No employee found with the given Employee Code");
      return;
    }
  
    if (Object.keys(pdfData).length === 0) {
      alert("No PDF data available to upload");
      return;
    }
  
    const formData = new FormData();
    const fileDataArray = [];
  
    names.forEach((name) => {
      const storedData = pdfData[name];
      const matchname = referenceDetailscode?.find(
        (doc) => doc.ReferenceDetailsName === name
      );
  
      if (storedData) {
        const blob = base64ToBlob(storedData, "application/pdf");
        const subname = matchname.ReferenceDetailsCode;
        const newName = `${Khuid}_${subname}.pdf`;
  
        const matchingDocument = employeeDocument?.find(
          (doc) => doc.DocumentTypeName === name
        );
  
        const doctypid = referenceDetails?.find(
          (docs) => docs.DocumentTypeName === name
        );
  
        const employeeDocumentID = matchingDocument ? matchingDocument.EmployeeDocumentID : 0;
        const doctypeids = doctypid.DocumentTypeID;
        const storedResponse = JSON.parse(sessionStorage.getItem("response"));
        const mode = employeeDocumentID ? "E" : "N";
  
        const fileObject = {
          FactoryID: storedResponse.FactoryID,
          CreatedUserID: storedResponse.UserID,
          ModifiedUserID: employeeDocumentID ? storedResponse.UserID : 0,
          DocumentTypeID: doctypeids,
          DocumentTypeName: name,
          Attachment: newName,
          EmployeeDocumentID: employeeDocumentID,
          EmployeeNo: newemployeecode,
          Mode: mode
        };
  
        fileDataArray.push(fileObject);
        formData.append("UploadFiles", blob, newName);
      } else {
        console.log(`No data found for: ${name}`);
      }
    });

    await insertOrUpdateEmployeeDocument(fileDataArray);
    // setEmployeeDocument(null);
    console.log("File Data Array:", fileDataArray); // Display the new objects
  
    for (const [key, value] of formData.entries()) {
      // If the value is a Blob, you might want to display its name instead
      if (value instanceof Blob) {
        console.log(`${key}: ${value.name}`);
      } else {
        console.log(`${key}: ${value}`);
      }
    }

    const data = [
      { factoryid: 4, subdivision: 1, factoryname: "FWD" },
      { factoryid: 2, subdivision: 2, factoryname: "GD" },
      { factoryid: 3, subdivision: 22, factoryname: "TAD" },
      { factoryid: 7, subdivision: 17, factoryname: "RF" },
      { factoryid: 5, subdivision: 4, factoryname: "LGD" },
      { factoryid: 5, subdivision: 20, factoryname: "LGD" ,subcat:"LPD"},
      { factoryid: 5, subdivision: 23, factoryname: "LGD" ,subcat:"unit3"},
      { factoryid: 5, subdivision: 24, factoryname: "LGD",subcat:"unit4" },
      // { factoryid: 5, subdivision: 6, factoryname: "RAB" },
    ];

    const storedResponse = JSON.parse(sessionStorage.getItem("response"));
    const factoryID = storedResponse?.FactoryID;
    const SubDivisionID= storedResponse?.SubDivisionID;
    const factoryData = data.find(item => item.subdivision === SubDivisionID);
    console.log(factoryData.factoryname);
    try {
      setLoadings(true);
      const response = await axios.post("https://service.khexports.in/api/common/saveAttachment", formData, {
        params: {
          bucketName: "one-erp-live",
          storageMethod: "S3",
          subFolderName: `${factoryData.factoryname}/EmployeeDocument`,
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      setLoadings(false);

      console.log("Successfully uploaded all files:", response.data);
      alert("Successfully uploaded all files");
      // Resetting states
      setPdfData({});
      setSelectedEmployee("");
      setEmployeeDocument(null);
      setnewpdf(null);
      setSelectedName("");
      setnewSelectedName("");
      setnames("");
      setPageNumbers(1);
      setFile("");
      setPdfUrl(null);
      document.getElementById("fileInput").value = "";
      setSelectedEmployee("");
      setFilteredEmployees([]);
  
      // Show success toast after upload
      // setShowToast(true); // Show the toast
      // setTimeout(() => setShowToast(false), 3000); // Hide the toast after 3 seconds
  
    } catch (error) {
      setLoadings(false);
      console.error("Error uploading files:", error.response ? error.response.data : error.message);
    }
  };
  

  // mainconst sendFilesToBackend = async (e) => {
  //     e.preventDefault();

  //     // const employeeId = employeecode;
  //     const formData = new FormData();
  //     // formData.append('employeeId', employeecode);
  //     // append('UploadFiles', pdfBlob, `${newFileName}.pdf`);

  //     // Removed these from formData:
  //     // formData.append('bucketName', 'one-erp-live');
  //     // formData.append('storageMethod', 'S3');
  //     // formData.append('subFolderName', 'EmployeeDocument');

  //     names.forEach((name) => {
  //         const storedData = pdfData[name];

  //         if (storedData) {
  //             const employeeId = employeecode;
  //             const blob = base64ToBlob(storedData, 'application/pdf');
  //             formData.append('UploadFiles', blob, `${employeeId}_${name}.pdf`);
  //         } else {
  //             console.log(`No data found for: ${name}`);
  //         }
  //     });

  //     try {
  //         // Add the parameters in the URL query string
  //         const response = await axios.post('https://localhost:7016/api/common/saveAttachment', formData, {
  //             params: {
  //                 bucketName: 'one-erp-live',
  //                 storageMethod: 'S3',
  //                 subFolderName: 'GD/EmployeeDocument',
  //             },
  //             headers: {
  //                 'Content-Type': 'multipart/form-data', // Important for file uploads
  //             },
  //         });

  //         console.log('Successfully uploaded all files:', response.data);
  //         alert(response.data);
  //     } catch (error) {
  //         console.error('Error uploading files:', error.response ? error.response.data : error.message);
  //     }

  //     setPdfData({});
  // };

  // const sendFilesToBackend = async (e) => {
  //     e.preventDefault();

  //     // Create a new FormData object
  //     const formData = new FormData();
  //     formData.append('employeeId', employeecode);
  //     // append('UploadFiles', pdfBlob, `${newFileName}.pdf`);
  //     formData.append('bucketName', 'one-erp-live');
  //     formData.append('storageMethod', 's3');
  //     formData.append('subFolderName', 'EmployeeDocument');
  //     // Loop through each name in the `names` array
  //     names.forEach((name) => {
  //         const storedData = pdfData[name]; // Get base64 string from state

  //         if (storedData) {
  //             const employeeId = employeecode; // Assuming employeecode is the employee ID
  //             const blob = base64ToBlob(storedData, 'application/pdf'); // Convert base64 to Blob

  //             // Append the file to FormData with the specified naming convention
  //             formData.append('UploadFiles', blob, `${employeeId}_${name}.pdf`);
  //              // Change 'file' to 'files' for multiple files
  //         } else {
  //             console.log(`No data found for: ${name}`);
  //         }
  //     });

  //     try {
  //         // Send POST request to your backend using Axios
  //         const response = await axios.post('https://service.khexports.in/api/', formData, {
  //             headers: {
  //                 'Content-Type': 'multipart/form-data', // Important for file uploads
  //             },
  //         });

  //         console.log('Successfully uploaded all files:', response.data);
  //     } catch (error) {
  //         console.error('Error uploading files:', error.response ? error.response.data : error.message);
  //     }

  //     setPdfData({}); // Reset pdfData if needed
  // };

  // const downloadFiles = (e) => {
  //     // e.preventDefault();

  //     // Iterate over each name in the `names` array
  //     names.forEach((name) => {
  //         const storedData = pdfData[name]; // Get base64 string from state instead of localStorage

  //         if (storedData) {
  //             const blob = base64ToBlob(storedData, 'application/pdf'); // Convert base64 to Blob
  //             const url = window.URL.createObjectURL(blob); // Create URL from Blob
  //             const link = document.createElement('a');
  //             link.href = url;
  //             link.setAttribute('downloa+d', `${employeecode}_${name}.pdf`); // Download as PDF
  //             document.body.appendChild(link);
  //             link.click();
  //             document.body.removeChild(link); // Cleanup
  //             window.URL.revokeObjectURL(url); // Free memory
  //         } else {
  //             console.log(`No data found for: ${name}`);
  //         }
  //     });
  //     setPdfData({});
  // };

  const downloadFiles = (e) => {
    // e.preventDefault();

    // Iterate over each key in the `pdfData` object (all the files in `pdfData`)
    Object.keys(pdfData).forEach((name) => {
      const storedData = pdfData[name]; // Get base64 string from state instead of localStorage

      if (storedData) {
        const blob = base64ToBlob(storedData, "application/pdf"); // Convert base64 to Blob
        const url = window.URL.createObjectURL(blob); // Create URL from Blob
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${name}.pdf`); // Download as PDF  ${employeecode}_
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Cleanup
        window.URL.revokeObjectURL(url); // Free memory
      } else {
        console.log(`No data found for: ${name}`);
      }
    });

    setPdfData({}); // Clear the pdfData after downloading all files
  };

  const mergePdfs = async (existingBlobString, newBlob) => {
    const existingPdfBytes = await existingBlobString.arrayBuffer();
    const newPdfBytes = await newBlob.arrayBuffer();

    const existingPdfDoc = await PDFDocument.load(existingPdfBytes);
    const newPdfDoc = await PDFDocument.load(newPdfBytes);

    const mergedPdfDoc = await PDFDocument.create();

    // Add pages from the existing PDF
    const existingPages = await mergedPdfDoc.copyPages(
      existingPdfDoc,
      existingPdfDoc.getPageIndices()
    );
    existingPages.forEach((page) => mergedPdfDoc.addPage(page));

    // Add pages from the new PDF
    const newPages = await mergedPdfDoc.copyPages(
      newPdfDoc,
      newPdfDoc.getPageIndices()
    );
    newPages.forEach((page) => mergedPdfDoc.addPage(page));

    const mergedPdfBytes = await mergedPdfDoc.save();
    return new Blob([mergedPdfBytes], { type: "application/pdf" });
  };

  const handleselect = async (newblob) => {
    if (pdfData[selectedName]) {
      // If PDF data for this name already exists in the state
      const existingBlobString = pdfData[selectedName];
      const existingBlob = base64ToBlobs(existingBlobString);
      console.log("This is the original blob", existingBlob);

      // Combine the new blob with the existing one
      const mergedPdfBlob = await mergePdfs(existingBlob, newblob);
      console.log("This is the merged PDF Blob", mergedPdfBlob);

      // setnewblob(mergedPdfBlob);

      const pdfUr = window.URL.createObjectURL(mergedPdfBlob);

      setnewpdf(pdfUr);
      setnames(selectedName);
      // Convert the merged Blob to base64 and update the state
      blobToBase64(mergedPdfBlob, (base64String) => {
        setPdfData((prevPdfData) => ({
          ...prevPdfData,
          [selectedName]: base64String, // Update state with merged PDF base64
        }));
        console.log("Stored base64 string in state:", base64String);
        // setnewpdf(null);
       // setPageNumbers(1);
        // setSelectedName(newFileName);
        //  setnewSelectedName(selectedName);

        // alert(`Saved to "${selectedName}".`);
      });
    } else {
      setnames(selectedName);
      // If no existing PDF data, store the new blob's base64
      blobToBase64(newblob, (base64String) => {
        setPdfData((prevPdfData) => ({
          ...prevPdfData,
          [selectedName]: base64String, // Store new PDF base64 in state
        }));
        console.log("Stored base64 string in state:", base64String);
        // setnewpdf(null);
        // setPageNumbers('');
        // setSelectedName('');
        // setSelectedName(newFileName);
        // setnewSelectedName(selectedName);
        // alert(`Saved to "${selectedName}".`);
      });
    }
  };

  const removePagesFromPdf = async () => {
    if (!file) {
      alert("Please upload a PDF file.");
      return;
    }

    const reader = new FileReader();

    reader.onload = async (event) => {
      const existingPdfBytes = event.target.result;

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const totalPages = pdfDoc.getPageCount();

      // Convert page numbers input into an array
      const pagesToRemove = Array.isArray(pageNumbers)
        ? pageNumbers
        : [parseInt(pageNumbers) - 1]; // Convert to zero-indexed array

      // Create a new PDF without the pages to remove
      const newPdfDoc = await PDFDocument.create();
      let hasValidPages = false; // Flag to track if any pages were added

      for (let i = 0; i < totalPages; i++) {
        if (!pagesToRemove.includes(i)) {
          const [page] = await newPdfDoc.copyPages(pdfDoc, [i]);
          newPdfDoc.addPage(page);
          hasValidPages = true; // Mark that we have valid pages
        }
      }

      // If no valid pages remain, clear the PDF URL
      if (!hasValidPages) {
        setPdfUrl(null);
        pdfBlob = null;
        setdisable(true);
        setFile(null);

        // Clear the PDF URL to show the message
        return; // Exit the function
      }

      const newPdfBytes = await newPdfDoc.save();
      const blob = new Blob([newPdfBytes], { type: "application/pdf" });
      setFile(blob);
      const pdfUrl = URL.createObjectURL(blob);
      setPdfUrl(pdfUrl);
    //   
    
    };

    reader.readAsArrayBuffer(file);
  };

  const blobToBase64 = (blob, callback) => {
    const reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result.split(",")[1]); // Get base64 without the data URL prefix
    };
    reader.readAsDataURL(blob); // Converts the Blob to a base64 encoded string
  };

  //   useEffect(() => {
  //     if (pdfData[newselectedName]) {
  //         // Assuming mergedPdfBlob is passed from somewhere, make sure it is defined
  //         setnames(newselectedName);

  //         const existingBlobString = pdfData[newselectedName];
  //         const existingBlob = base64ToBlobs(existingBlobString);

  //         if (existingBlob) {
  //             const pdfUrl = window.URL.createObjectURL(existingBlob);
  //             setnewpdf(pdfUrl);

  //             // Clean up the object URL on component unmount
  //             return () => window.URL.revokeObjectURL(pdfUrl);
  //         } else {
  //             console.error("Blob conversion failed for", newselectedName);

  //         }
  //     }
  // }, [pdfData, newselectedName]);

  // const checkdata=()=>{
  //     if (pdfData[newselectedName]) {
  //         // Assuming mergedPdfBlob is passed from somewhere, make sure it is defined
  //         setnames(newselectedName);

  //         const existingBlobString = pdfData[newselectedName];
  //         const existingBlob = base64ToBlobs(existingBlobString);

  //         if (existingBlob) {
  //             const pdfUrl = window.URL.createObjectURL(existingBlob);
  //             setnewpdf(pdfUrl);

  //             // Clean up the object URL on component unmount
  //             return () => window.URL.revokeObjectURL(pdfUrl);
  //         } else {
  //             console.error("Blob conversion failed for", newselectedName);

  //         }
  //     }else{
  //         setnames(`No pages add in ${newselectedName}`)
  //         setnewpdf(null);
  //     }
  // }

  const checkdata = (name) => {
    if (pdfData[name]) {
      // Assuming mergedPdfBlob is passed from somewhere, make sure it is defined
      setnames(name);

      const existingBlobString = pdfData[name];
      const existingBlob = base64ToBlobs(existingBlobString);

      if (existingBlob) {
        const pdfUrl = window.URL.createObjectURL(existingBlob);
        setnewpdf(pdfUrl);

        // Clean up the object URL on component unmount
        return () => window.URL.revokeObjectURL(pdfUrl);
      } else {
        console.error("Blob conversion failed for", name);
      }
    } else {
      setnames(`No pages added in ${name}`);
      setnewpdf(null);
    }
  };

  

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    if (selectedFile && selectedFile.type === "application/pdf") {
      const fileUrl = URL.createObjectURL(selectedFile);
      setPdfUrl(fileUrl);
    } else {
     if(file)
      setFile(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent double submission

    if (!file || !pageNumbers) {
      alert("Please upload a file");
      // alert('Please upload a file and specify the pages');
      return;
    }

    setIsSubmitting(true); // Disable submit button

    const formData = new FormData();
    formData.append("file", file);
    formData.append("newFileName", newFileName);
    formData.append("pageNumbers", pageNumbers);

    try {
      // const response = await axios.post('http://localhost:8081/api/pdf/download', formData, {
      //     headers: {
      //         'Content-Type': 'multipart/form-data',
      //     },
      //     responseType: 'blob', // Expecting file as a response (PDF)
      // });

      // pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      pdfBlob = await extractPagesFromPdf();
      setnewblob(pdfBlob);

      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      setnewpdf(pdfUrl);
      await removePagesFromPdf();
     // setPageNumbers(1); // Reset to the first page
     
      await handleselect(pdfBlob);
    } catch (error) {
      alert(error);
      //alert("Invalid input: Double commas (,,) are not allowed in the page numbers");
    } finally {
      setIsSubmitting(false); // Re-enable submit button
    }
  };

  const extractPagesFromPdf = async () => {
    if (!file) {
      alert("Please upload a PDF file.");
      return null; // Return null if no file is uploaded
    }

    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = async (event) => {
        try {
          const existingPdfBytes = event.target.result;

          // Load the existing PDF document
          const pdfDoc = await PDFDocument.load(existingPdfBytes);

          // Get the total number of pages in the PDF
          const totalPages = pdfDoc.getPageCount();

          // Convert page numbers input into an array
          const pagesToExtract = Array.isArray(pageNumbers)
            ? pageNumbers
            : [parseInt(pageNumbers) - 1];

          // Create a new PDF document
          const newPdfDoc = await PDFDocument.create();

          // Loop through the pages and add the specific pages to the new PDF
          for (let i of pagesToExtract) {
            if (i >= 0 && i < totalPages) {
              const [page] = await newPdfDoc.copyPages(pdfDoc, [i]);
              newPdfDoc.addPage(page);
            }
          }

          // Save the new PDF and convert it to bytes
          const newPdfBytes = await newPdfDoc.save();

          // Create a Blob for the extracted file
          const blob = new Blob([newPdfBytes], { type: "application/pdf" });

          // Resolve the promise with the blob
          resolve(blob);
        } catch (error) {
          reject(error); // Reject the promise if an error occurs
        }
      };

      reader.readAsArrayBuffer(file);
    });
  };

  // const handleSubmit = async (e) => {
  //     e.preventDefault();

  //     if (isSubmitting) return;  // Prevent double submission

  //     if (!file || !pageNumbers) {
  //         alert('Please upload a file');
  //         // alert('Please upload a file and specify the pages');
  //         return;
  //     }

  //     setIsSubmitting(true);  // Disable submit button

  //     const formData = new FormData();
  //     formData.append('file', file);
  //     formData.append('newFileName', newFileName);
  //     formData.append('pageNumbers', pageNumbers);

  //     try {
  //         const response = await axios.post('http://localhost:8081/api/pdf/download', formData, {
  //             headers: {
  //                 'Content-Type': 'multipart/form-data',
  //             },
  //             responseType: 'blob', // Expecting file as a response (PDF)
  //         });

  //         pdfBlob = new Blob([response.data], { type: 'application/pdf' });
  //         setnewblob(pdfBlob);

  //         const pdfUrl = window.URL.createObjectURL(pdfBlob);
  //         setnewpdf(pdfUrl);
  //         removePagesFromPdf();
  //         await handleselect(pdfBlob);

  //     } catch (error) {
  //        alert(error);
  //         //alert("Invalid input: Double commas (,,) are not allowed in the page numbers");
  //     } finally {
  //         setIsSubmitting(false);  // Re-enable submit button
  //     }
  // };

  const getPdfPageCount = async (base64String) => {
    const pdfData = atob(base64String); // Decode base64 to binary string
    const uint8Array = new Uint8Array(
      [...pdfData].map((char) => char.charCodeAt(0))
    );

    const pdfDocument = await pdfjsLib.getDocument(uint8Array).promise;
    return pdfDocument.numPages;
  };

  const handleClick = (name) => {
    setnewSelectedName(name); // Set the selected PDF name
    checkdata(name);
    setSelectedName(name); // Call checkdata with the selected name
  };

  const extractLastPageFromPdf = async () => {
    if (pdfData[newselectedName]) {
      const existingselectedstring = pdfData[newselectedName];
      const existingBlob = base64ToBlobs(existingselectedstring); // Ensure this function works correctly
      console.log("This is the blob", existingBlob);

      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onload = async (event) => {
          try {
            console.log("Existing blob", existingBlob);
            const existingPdfBytes = await reader.result; // Get the ArrayBuffer from the FileReader

            // Load the existing PDF document
            const pdfDoc = await PDFDocument.load(existingPdfBytes);

            // Get the total number of pages in the PDF
            const totalPages = pdfDoc.getPageCount();

            // The index of the last page (zero-based)
            const lastPageIndex = totalPages - 1;

            // Create a new PDF document
            const newPdfDoc = await PDFDocument.create();

            // Extract the last page and add it to the new PDF
            const [lastPage] = await newPdfDoc.copyPages(pdfDoc, [
              lastPageIndex,
            ]);
            newPdfDoc.addPage(lastPage);

            // Save the new PDF and convert it to bytes
            const newPdfBytes = await newPdfDoc.save();

            // Create a Blob for the extracted file
            const blob = new Blob([newPdfBytes], { type: "application/pdf" });
            console.log("Blob", blob);
            // Resolve the promise with the blob
            resolve(blob);
          } catch (error) {
            console.error("Error extracting the last page:", error); // Log the error
            reject(error); // Reject the promise if an error occurs
          }
        };

        // Read the existingBlob as an ArrayBuffer
        reader.readAsArrayBuffer(existingBlob);
      });
    }
  };

  const mergePdfsreverse = async (existingBlob, newBlob) => {
    const existingPdfBytes = await file.arrayBuffer();
    const newPdfBytes = await newBlob.arrayBuffer();

    const existingPdfDoc = await PDFDocument.load(existingPdfBytes);
    const newPdfDoc = await PDFDocument.load(newPdfBytes);

    const mergedPdfDoc = await PDFDocument.create();

    // Add pages from the new PDF (newBlob) first
    const newPages = await mergedPdfDoc.copyPages(
      newPdfDoc,
      newPdfDoc.getPageIndices()
    );
    newPages.forEach((page) => mergedPdfDoc.addPage(page));

    // Add pages from the existing PDF (existingBlobString) after
    const existingPages = await mergedPdfDoc.copyPages(
      existingPdfDoc,
      existingPdfDoc.getPageIndices()
    );
    existingPages.forEach((page) => mergedPdfDoc.addPage(page));

    const mergedPdfBytes = await mergedPdfDoc.save();
    return new Blob([mergedPdfBytes], { type: "application/pdf" });
  };

  const removeLastPageFromPdf = async () => {
    if (pdfData[newselectedName]) {
      const existingselectedstring = pdfData[newselectedName];
      const existingBlob = base64ToBlobs(existingselectedstring);
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onload = async (event) => {
          try {
            const existingPdfBytes = await reader.result;

            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const totalPages = pdfDoc.getPageCount();

            // The last page to remove will have an index of totalPages - 1
            const lastPageIndex = totalPages - 1;

            // Create a new PDF without the last page
            const newPdfDoc = await PDFDocument.create();
            let hasValidPages = false; // Flag to track if any pages were added

            // Copy all pages except the last one into the new PDF
            for (let i = 0; i < totalPages; i++) {
              if (i !== lastPageIndex) {
                // Skip the last page
                const [page] = await newPdfDoc.copyPages(pdfDoc, [i]);
                newPdfDoc.addPage(page);
                hasValidPages = true; // Mark that we have valid pages
              }
            }

            // If no valid pages remain, clear the PDF URL
            if (!hasValidPages) {
              // setnewpdf(null);
              // pdfBlob = null;

              if (pdfData[newselectedName]) {
                // Create a copy of pdfData to avoid direct state mutation
                // const updatedData = { ...pdfData };

                // // Remove the key from the copied object
                // delete updatedData[newselectedName];

                // // Update the state with the modified object
                // setPdfData(updatedData);
                alert(`only one page is left in ${newselectedName}.pdf`);
                setIsSubmittingreverse(false);
              }

              // setdisable(true);
              return; // Exit the function
            }

            const newPdfBytes = await newPdfDoc.save();
            const blob = new Blob([newPdfBytes], { type: "application/pdf" });
            // setnewblob(blob);
            // const pdfUrl = URL.createObjectURL(blob);
            // setnewpdf(pdfUrl);
            resolve(blob);
          } catch (error) {
            console.error("Error extracting the last page:", error); // Log the error
            reject(error); // Reject the promise if an error occurs
          }
        };

        reader.readAsArrayBuffer(existingBlob);
      });
    }
  };

  const mergePdfsreverses = async (existingBlob, newBlob) => {
    const existingPdfBytes = await file.arrayBuffer();
    const newPdfBytes = await newBlob.arrayBuffer();

    const existingPdfDoc = await PDFDocument.load(existingPdfBytes);
    const newPdfDoc = await PDFDocument.load(newPdfBytes);

    const mergedPdfDoc = await PDFDocument.create();

    // Add pages from the existing PDF first
    const existingPages = await mergedPdfDoc.copyPages(
      existingPdfDoc,
      existingPdfDoc.getPageIndices()
    );
    existingPages.forEach((page) => mergedPdfDoc.addPage(page));

    // Insert new pages at the specified page number
    const newPages = await mergedPdfDoc.copyPages(
      newPdfDoc,
      newPdfDoc.getPageIndices()
    );

    // Add the new pages at the specified index (pageNumbers)
    // Ensure pageNumbers is within the valid range
    const insertIndex = Math.min(pageNumbers-1, existingPages.length);
    newPages.forEach((page) => mergedPdfDoc.insertPage(insertIndex, page));

    const mergedPdfBytes = await mergedPdfDoc.save();
    return new Blob([mergedPdfBytes], { type: "application/pdf" });
};

  const handleSubmitreverse = async (e) => {
    e.preventDefault();

    if (!pdfData[newselectedName]) {
      alert("select the category");
    } else {
      // if (isSubmitting) return;  // Prevent double submission

      // if (!file || !pageNumbers) {
      //     alert('Please upload a file');
      //     // alert('Please upload a file and specify the pages');
      //     return;
      // }

      setIsSubmittingreverse(true); // Disable submit button

      // const formData = new FormData();
      // formData.append('file', file);
      // formData.append('newFileName', newFileName);
      // formData.append('pageNumbers', pageNumbers);

      try {
        // const response = await axios.post('http://localhost:8081/api/pdf/download', formData, {
        //     headers: {
        //         'Content-Type': 'multipart/form-data',
        //     },
        //     responseType: 'blob', // Expecting file as a response (PDF)
        // });

        // pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        const myblob = await extractLastPageFromPdf();
        const myblob2 = await removeLastPageFromPdf();
        await handleselectreverse(myblob2);
        if (file) {
          const files = await mergePdfsreverses(file, myblob);
          setFile(files);
          const pdfUrls = window.URL.createObjectURL(files);
          setPdfUrl(pdfUrls);
        } else {
          setFile(myblob);
          const pdfUrls = window.URL.createObjectURL(myblob);
          setPdfUrl(pdfUrls);
          setdisable(false);
        }
        console.log("my blob", myblob);
        setnewblob(myblob2);

        const pdfUrl = window.URL.createObjectURL(myblob2);
        setnewpdf(pdfUrl);

        // const pdfUrls = window.URL.createObjectURL(files);
        // setPdfUrl(pdfUrls);
        // const merged=mergePdfsreverse(existingBlob,pdfBlob);
        // setFie(merged);
        // await handleselect(pdfBlob);
      } catch (error) {
        alert(error);
        //alert("Invalid input: Double commas (,,) are not allowed in the page numbers");
      } finally {
        setIsSubmittingreverse(false); // Re-enable submit button
      }
    }
  };

  const handleselectreverse = async (newblob) => {
    if (pdfData[newselectedName]) {
      // If PDF data for this name already exists in the state
      // const existingBlobString = pdfData[selectedName];
      // const existingBlob = base64ToBlobs(existingBlobString);
      // console.log("This is the original blob", existingBlob);

      // // Combine the new blob with the existing one
      // const mergedPdfBlob = await mergePdfs(existingBlob, newblob);
      // console.log("This is the merged PDF Blob", mergedPdfBlob);

      // // setnewblob(mergedPdfBlob);

      // const pdfUr = window.URL.createObjectURL(mergedPdfBlob);

      // setnewpdf(pdfUr);
      // setnames(selectedName);
      // Convert the merged Blob to base64 and update the state
      blobToBase64(newblob, (base64String) => {
        setPdfData((prevPdfData) => ({
          ...prevPdfData,
          [newselectedName]: base64String, // Update state with merged PDF base64
        }));
        console.log("Stored base64 string in state:", base64String);
        // setnewpdf(null);
        // setPageNumbers(1);
        // setnewSelectedName('');
        // alert(`Saved to "${selectedName}".`);
      });
    } else {
      // //  setnames(selectedName);
      // // If no existing PDF data, store the new blob's base64
      // blobToBase64(newblob, (base64String) => {
      //     setPdfData(prevPdfData => ({
      //         ...prevPdfData,
      //         [selectedName]: base64String  // Store new PDF base64 in state
      //     }));
      //     console.log("Stored base64 string in state:", base64String);
      //     // setnewpdf(null);
      //     // setPageNumbers('');
      //     setSelectedName('');
      //     // alert(`Saved to "${selectedName}".`);
      // });
      alert("select the category");
    }
  };

 
  //         useEffect(() => {
  //   const loadPdf = async () => {
  //     if (file) {
  //       try {
  //         const fileReader = new FileReader();

  //         fileReader.onload = async (e) => {
  //           const pdfData = e.target.result;

  //           // Load the PDF document from the ArrayBuffer
  //           const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
  //           setPdfDoc(pdf);
  //           renderPage(1);
  //           // setPageNumbers(1); // Reset to the first page
  //           // await renderPage(pageNumbers); // Render the first page
  //         };

  //         fileReader.readAsArrayBuffer(file); // Read the file as ArrayBuffer
  //       } catch (error) {
  //         console.error("Error loading PDF:", error);
  //       }
  //     }
  //   };

  //   loadPdf();
  // }, [file]);

  //         const [renderingTask, setRenderingTask] = useState(null);

  //         const renderPage = async (pageNumber) => {
  //           if (!pdfDoc) return;

  //           if (renderingTask) {
  //             renderingTask.cancel();
  //           }

  //           const page = await pdfDoc.getPage(pageNumber);
  //           const scale = 5.0;
  //           const viewport = page.getViewport({ scale });

  //           const canvas = canvasRef.current;
  //           const context = canvas.getContext('2d');

  //           canvas.height = viewport.height;
  //           canvas.width = viewport.width;

  //           const renderContext = {
  //             canvasContext: context,
  //             viewport: viewport,
  //           };

  //           const task = page.render(renderContext);
  //           setRenderingTask(task); // Track the current rendering task

  //           // Wait for the rendering to complete
  //           await task.promise;
  //           setRenderingTask(null); // Clear the task after rendering is complete
  //         }


  useEffect(() => {
    const loadPdf = async () => {
      if (file) {
        const reader = new FileReader();

        reader.onload = async (e) => {
          const arrayBuffer = e.target.result;

          try {
            const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
            setPdfDoc(pdf); // Set the PDF document state

            const totalPages = pdf.numPages; // Get the total number of pages

            // Ensure the page number is within the valid range
            const validPageNumber = Math.min(pageNumbers, totalPages);
            setPageNumbers(validPageNumber);
            // Render the valid page
            renderPage(validPageNumber, pdf);
          } catch (error) {
            console.error("Error loading PDF:", error);
          }
        };

        reader.readAsArrayBuffer(file);
      }
    };

    loadPdf();
  }, [file, pageNumbers]); // Added pageNumbers as a dependency

  
  // const renderPage = async (pageNumber, pdfDoc) => {
  //   console.log("Attempting to render page:", pageNumber);
    
  //   if (!pdfDoc) {
  //     console.log("PDF document is not loaded yet.");
  //     return;
  //   }
  
  //   const page = await pdfDoc.getPage(pageNumber);
  //   const scale = 1.5; // Start with a base scale
  //   const viewport = page.getViewport({ scale });
  
  //   const canvas = canvasRef.current;
  //   const context = canvas.getContext("2d");
  
  //   // Get device pixel ratio
  //   const devicePixelRatio = window.devicePixelRatio || 1;
  
  //   // Set the desired display size (600px width in this case)
  //   const desiredWidth = 550; // You can set this to any width you need
  //   const scaleFactor = desiredWidth / viewport.width; // Scale to fit the desired width
  //    const scaledHeight = viewport.height * scaleFactor; // Maintain aspect ratio
  //   // const scaledHeight=800;
  
  //   // Set the display size of the canvas (this controls the visible size on the screen)
  //   canvas.style.width = `${desiredWidth}px`;
  //   canvas.style.height = `${scaledHeight}px`;
  
  //   // Set the actual internal resolution of the canvas (scaled by devicePixelRatio for clarity)
  //   canvas.width = Math.floor(desiredWidth * devicePixelRatio);
  //   canvas.height = Math.floor(scaledHeight * devicePixelRatio);
  
  //   // Scale the drawing context to match the pixel density of the device
  //   context.scale(devicePixelRatio, devicePixelRatio);
  
  //   console.log("Canvas dimensions before rendering:", canvas.width, canvas.height);
  
  //   // Clear the canvas before rendering a new page
  //   context.clearRect(0, 0, canvas.width, canvas.height);
  
  //   const renderContext = {
  //     canvasContext: context,
  //     viewport: page.getViewport({ scale: scale * scaleFactor }), // Apply scale factor to the viewport
  //   };
  
  //   try {
  //     await page.render(renderContext).promise;
  //     console.log("Page rendered successfully.");
  //   } catch (error) {
  //     console.error("Error rendering page:", error);
  //   }
  // };
  
  

  
// const renderPage = async (pageNum, pdfDoc) => {
//     const page = await pdfDoc.getPage(pageNum);
  
//     const outputScale = window.devicePixelRatio || 1;
//     const viewport = page.getViewport({ scale: 1.4 }); // Set initial scale to 1 or as per requirement
//     const canvas = canvasRef.current; // Your canvas ID
//     const context = canvas.getContext('2d');
  
//     // Adjust canvas dimensions for clarity
//     canvas.width = Math.floor(viewport.width * outputScale);
//     canvas.height = Math.floor(viewport.height * outputScale);
//     canvas.style.width = `${Math.floor(550)}px`;
//     canvas.style.height = `${Math.floor(800)}px`;
  
//     const transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;
  
//     // Set up render context for PDF
//     const renderContext = {
//       canvasContext: context,
//       transform: transform,
//       viewport: viewport
//     };
  
//     const renderTask = page.render(renderContext);
    
//     renderTask.promise.then(() => {
//       console.log("Page rendered successfully");
//     }).catch((error) => {
//       console.error("Error rendering page:", error);
//     });
//   };
let isRendering = false;

const renderPage = async (pageNumber, pdfDoc) => {
  if (!pdfDoc || isRendering) return; // Prevent re-render if already rendering
  
  isRendering = true; // Set rendering flag
  
  try {
    const page = await pdfDoc.getPage(pageNumber);
    const scale = 0.8;
    const viewport = page.getViewport({ scale });

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    // Adjust canvas size to the viewport
    const viewportHeight = 600;
    canvas.height = viewportHeight;
    canvas.width = viewport.width;

    // Set up the rendering context
    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    // Render the page to the canvas and await the promise to complete
    await page.render(renderContext).promise;
  } catch (error) {
    console.error("Error rendering page:", error);
  } finally {
    isRendering = false; // Reset rendering flag once done
  }
};




  const nextPage = () => {
    if (pageNumbers < pdfDoc.numPages) {
      setPageNumbers((prevPage) => {
        const newPage = prevPage + 1;
        renderPage(newPage,pdfDoc);
        return newPage;
      });
    }
  };

  const prevPage = () => {
    if (pageNumbers > 1) {
      setPageNumbers((prevPage) => {
        const newPage = prevPage - 1;
        renderPage(newPage,pdfDoc);
        return newPage;
      });
    }
  };


  // const [employeecode, setEmployeeCode] = useState("");
 

  const employeess = [
      { code: "E001", name: "John Doe", department: "HR" },
      { code: "E002", name: "Jane Smith", department: "Finance" },
      { code: "E003", name: "Mark Johnson", department: "IT" },
      // Add more employee data as needed
  ];

  // const handleEmployeeCodeChanges = (e) => {
  //     const value = e.target.value;
  //     setemployeecode(value);

  //     if (value) {
  //         const filtered = employeess.filter((employee) =>
  //             employee.code.toLowerCase().includes(value.toLowerCase())
  //         );
  //         setFilteredEmployees(filtered);
  //     } else {
  //         setFilteredEmployees([]);
  //     }
  // };

  const handleEmployeeCodeChanges = (e) => {
    const value = e.target.value;
    setemployeecode(value);
    setSelectedEmployee(value);
    setIsGridOpen(true);

    if (value) {
        const filtered = employees.filter((employee) =>
            employee.EmployeeCode.toLowerCase().includes(value.toLowerCase()) ||
            employee.EmployeeName.toLowerCase().includes(value.toLowerCase()) ||
            (employee.KHUID && employee.KHUID.toString().toLowerCase().includes(value.toLowerCase()))
        );
        setFilteredEmployees(filtered);
    } else {
        setFilteredEmployees([]);
    }
};



// useEffect(() => {
//     if (pdfUrl) {
//         const eventBus = new pdfjsLib.EventBus();

// eventBus.on('pagechange', function (event) {
//     const currentPage = event.pageNumber; // Get the current page number
//     window.parent.postMessage({ type: 'PAGE_CHANGE', pageNumber: currentPage }, '*');
// });
//       // Extract the origin from the pdfUrl
//       const iframeOrigin = new URL(pdfUrl).origin;

//       // Listener for messages from the iframe
//       const messageListener = (event) => {
//         // Ensure the message is from the correct origin
//         if (event.origin !== iframeOrigin) return;

//         // Process the message (e.g., get the page number)
//         if (event.data && event.data.pageNumber) {
//           console.log('Current Page:', event.data.pageNumber); // Log the current page number
//         }
//       };

//       // Attach the event listener for postMessage
//       window.addEventListener('message', messageListener);

//       // Cleanup the event listener when the component unmounts
//       return () => {
//         window.removeEventListener('message', messageListener);
//       };
//     }
//   }, [pdfUrl]);

 

//const iframeRef = useRef(null);
// useEffect(() => {
//     // Extract the origin from the newpdf URL
//     if(pdfUrl){
//         if (iframeRef.current) {
//             const iframe = iframeRef.current;
      
//             // Send a message to get the current page number (or other interaction)
//             const iframeOrigin = new URL(newpdf).origin;
//             iframe.contentWindow.postMessage('getPageNumber', iframeOrigin);
//           }
//         const iframeOrigin = new URL(pdfUrl).origin;

//     // Listener for messages from the iframe
//     const messageListener = (event) => {
//       // Ensure the message is from the correct origin
//       if (event.origin !== iframeOrigin) return;

//       // Process the message (e.g., get page number or other data)
//       console.log('Message from PDF iframe:', event.data);  // This will log the page number (or other info)
//     };

//     // Attach the event listener
//     window.addEventListener('message', messageListener);

   
//     // Clean up the event listener when component unmounts
//     return () => {
//       window.removeEventListener('message', messageListener);
//     };
//     }
//   }, [pdfUrl]);

  // Function to send a message to the iframe
//   const handleIframeLoad = () => {
  
//   };
// useEffect(() => {
//   // Extract the origin from the newpdf URL
//   if(pdfUrl){
//     const iframeOrigin = new URL(pdfUrl).origin;

//   // Listener for messages from the iframe
//   const messageListener = (event) => {
//     // Ensure the message is from the correct origin
//     if (event.origin !== iframeOrigin) return;

//     // Process the message (e.g., get page number or other data)
//     console.log('Message from PDF iframe:', event.data);  // This will log the page number (or other info)
//   };

//   // Attach the event listener
//   window.addEventListener('message', messageListener);

//   // Function to send a message to the iframe
//   const sendMessageToIframe = () => {
//     if (iframeRef.current) {
//       const iframe = iframeRef.current;

//       // Ensure iframe's contentWindow is available
//       if (iframe.contentWindow) {
//         // Send a message to get the current page number (or other interaction)
//         iframe.contentWindow.postMessage('getPageNumber', iframeOrigin);
//       }
//     }
//   };

//   // Wait for the iframe to load before sending the message
//   const iframe = iframeRef.current;
//   iframe.onload = () => {
//     // Once iframe is loaded, send the message to get the page number
//     sendMessageToIframe();
//   };

//   // Clean up the event listener when component unmounts
//   return () => {
//     window.removeEventListener('message', messageListener);
//   };
//   }
// }, [pdfUrl]);

// useEffect(() => {
//     const loadPDF = async () => {
//       const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
//       setPdfDoc(pdf);
//       setPageCount(pdf.numPages);
//       renderPage(pageNum);
//     };

//     loadPDF();
//   }, [file]);

//   // Render a specific page
//   const renderPage = (num) => {
//     pdfDoc.getPage(num).then((page) => {
//       const viewport = page.getViewport({ scale: 1.5 });
//       const canvas = canvasRef.current;
//       const ctx = canvas.getContext('2d');
//       canvas.height = viewport.height;
//       canvas.width = viewport.width;

//       const renderContext = {
//         canvasContext: ctx,
//         viewport: viewport,
//       };

//       page.render(renderContext);
//     });
//   };

//   // Show previous page
//   const showPrevPage = () => {
//     if (pageNum > 1) {
//       setPageNum(pageNum - 1);
//       renderPage(pageNum - 1);
//     }
//   };

//   // Show next page
//   const showNextPage = () => {
//     if (pageNum < pageCount) {
//       setPageNum(pageNum + 1);
//       renderPage(pageNum + 1);
//     }
//   };
// const downloadPdf = () => {
   
//       const link = document.createElement('a');
//       link.href = pdfUrl;
//       link.download = `remaining.pdf`; // Add "_remaining" to the filename
//       link.click();
 
//   }


  const downloadPdf = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
  
      // Provide a custom file name
      link.download = `remaining.pdf`; 
  
      link.click();
    } else {
      console.error("PDF URL is not available.");
    }
  };

// const downloadPdf = () => {
//     if (file && pdfUrl) {
//       const link = document.createElement('a');
//       link.href = pdfUrl;
  
//       // Get the original file name and append "_remaining"
//       const originalFileName = file.name.replace('.pdf', ''); // Remove .pdf extension
//       link.download = `${originalFileName}_remaining.pdf`; // Add "_remaining" to the filename
  
//       link.click();
//     } else {
//       console.error("No file selected or PDF URL is not available.");
//     }
//   };

if (loadings) {
  return (
    <div className="flex space-x-2 justify-center items-center fixed top-0 left-0 w-full h-full bg-transparent z-50">
      <span className="sr-only">Loading...</span>
      <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
      <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
      <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
    </div>
  );
}
  
  
  return (
    <>
  
    <div className="fixed top-16 left-0 w-full h-full font-sans text-gray-900 bg-gray-300 border ">
      <div className="flex justify-center w-full mx-auto  shadow-lg">
        <div className="grid grid-cols-1 sm:grid-cols-3  w-full h-screen bg-white sm:rounded-lg sm:shadow-xl">

          {/* Left Section: PDF Preview */}
         {/* Left Section: PDF Preview */}
         <div className=" p-2 bg-gray-50 border">
            <div className="mb-2 flex items-center">
              <input
               id="fileInput"
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}

                disabled={!selectedEmployee} 
                className="p-2 mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
              />
              <button
              onClick={downloadPdf}
              className="ml-2 p-2 bg-blue-500 text-white rounded-md shadow-md"
            >
              Save
            </button>
            </div>
            <div className="text-center mb-2">
              <h3 className="text-lg font-medium text-gray-700">PDF Preview</h3>
            </div>

            {pdfUrl ? (
              <div>
                <div className="flex justify-between mb-3">
                  <button
                    onClick={prevPage}
                    disabled={pageNumbers === 1}
                    className="p-2 bg-gray-200 rounded-md shadow-md"
                  >
                    Previous
                  </button>
                  <span className="text-sm text-gray-600">
                    Page {pageNumbers} of {pdfDoc ? pdfDoc.numPages : 0}
                  </span>
                  <button
                    onClick={nextPage}
                    disabled={pdfDoc && pageNumbers === pdfDoc.numPages}
                    className="p-2 bg-gray-200 rounded-md shadow-md"
                  >
                    Next
                  </button>
                </div>
                <canvas
                  ref={canvasRef}
                  className="w-full border border-gray-300 shadow-md"
                ></canvas>
              </div>
            ) : (
              <p className="pdfMessage text-center text-gray-500">
                No PDF file selected.
              </p>
            )}
          </div>
          {/* Center Section: Form Input */}
          <div className=" bg-white col-span-1">
            {/* <div className="text-center mb-10">
                            <h2 className="text-2xl font-semibold mb-2">Upload a PDF and Create a New PDF with Selected Pages</h2>
                            <p className="text-xs text-gray-500">File should be of format .pdf</p>
                        </div> */}
            <div className="m-5 mt-16 space-y-7">
              <form
                onSubmit={handleSubmit}
                className="bg-gray-100 rounded-lg shadow-inner border p-2"
              >
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                  PDF category:
                  </label>
                  {/* <input
                                required
                                    type="text"
                                      placeholder="Enter new filename"
                                    
                                    value={selectedName}
                                    // onChange={(e) => setSelectedName(e.target.value)}
                                    onChange={(e) => {
                                        setSelectedName(e.target.value);
                                        setnewSelectedName(e.target.value);
                                    }}
                                    className="p-2 mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
                                /> */}

                  <select
                    required
                    value={selectedName}
                    onChange={(e) => {
                      setSelectedName(e.target.value);
                      setnewSelectedName(e.target.value);
                    }}
                    className="p-2 mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
                  >
                    <option value="" disabled>
                      Select a name
                    </option>
                    {names.map((name, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <button 
                               disabled={disable}
                                type="submit" 
                                className="w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600"
                            >
                                {isSubmitting ? 'Processing...' : '>>>'}
                            </button> */}
                <div className="flex justify-center items-center">
                  <button
                    // disabled={disable || !file && !newblob}
                  
                    type="submit"
                    className={`flex w-full items-center justify-center bg-black text-white py-2 px-4 rounded-lg shadow cursor-pointer"}`}
                  >
                    {isSubmitting ? "Processing..." : ""}
                    <div className="flex justify-center items-center gap-1 font-semibold tracking-widest duration-300 hover:gap-2 hover:translate-x-4">
                      <svg
                        className="w-5 h-5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                          strokeLinejoin="round"
                          strokeLinecap="round"
                        ></path>
                      </svg>
                      <svg
                        className="w-5 h-5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                          strokeLinejoin="round"
                          strokeLinecap="round"
                        ></path>
                      </svg>
                      <svg
                        className="w-5 h-5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                          strokeLinejoin="round"
                          strokeLinecap="round"
                        ></path>
                      </svg>
                    </div>
                  </button>
                </div>

                {/* <button
                                onClick={handleSubmitreverse}
                                className="mt-3 w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600"
                                >
                                {Submittingreverse ? 'Processing...' : '<<<'} 
                            </button> */}
                <div className="flex justify-center items-center">
                  <button
                    onClick={handleSubmitreverse}
                    // disabled={disable}
                    type="submit"
                    className={`w-full mt-3 bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600`}
                  >
                    {/* ${disable ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} */}
                    {Submittingreverse ? "Processing..." : ""}
                    <div className=" flex justify-center items-center gap-1 font-semibold tracking-widest duration-300 hover:gap-2 hover:-translate-x-4">
                      <svg
                        className="w-5 h-5 transform rotate-[-180deg]"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                          strokeLinejoin="round"
                          strokeLinecap="round"
                        ></path>
                      </svg>
                      <svg
                        className="w-5 h-5 transform rotate-[-180deg]"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                          strokeLinejoin="round"
                          strokeLinecap="round"
                        ></path>
                      </svg>
                      <svg
                        className="w-5 h-5 transform rotate-[-180deg]"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                          strokeLinejoin="round"
                          strokeLinecap="round"
                        ></path>
                      </svg>
                    </div>
                  </button>
                </div>

                {/* <button 
                                type="submit" 
                                className=" mt-5 w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600"
                            >
                               backward
                            </button> */}
              </form>

              {/* <div className='bg-gray-100 rounded-lg shadow-inner border p-2'>
                        <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Category:</label>
            <select
                value={selectedName}
                onChange={(e) => setSelectedName(e.target.value)}
                className="p-2 mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
            >
                <option value="" disabled>Select a name</option>
                {names.map((name, index) => (
                    <option key={index} value={name}>
                        {name}
                    </option>
                ))}
            </select>
        </div>
          <button 
                              onClick={handleselect}
                                className="w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600"
                            >
                               Set Category
                            </button>
                        </div> */}
              <div className=" bg-gray-100 rounded-lg shadow-inner border p-2">
                <div className="items-center text-center justify-center overflow-auto">
                  {/* <h1 className="block text-sm font-medium text-gray-700">Check pdf here:</h1> */}
                </div>
                {/* <div className="flex mb-4 mt-1 space-x-2">
         
            <select
            required
                value={newselectedName}
                onChange={(e) => setnewSelectedName(e.target.value)}
                className="w-96 p-2 mt-1 block  text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
                
            >
                <option value="" disabled>Select a name</option>
                {names.map((name, index) => (
                    <option key={index} value={name}>
                        {name}
                    </option>
                ))}
            </select>
            <button 
                             onClick={checkdata}
                                className="  px-5 bg-indigo-500 text-white  rounded-lg shadow hover:bg-indigo-600"
                            >
                               Check
                            </button> 
        </div> */}
                {/* <div className="grid grid-cols-2 gap-4 border overflow-y-scroll max-h-96">
            <div className="font-bold border-r border-b py-3 bg-white sticky top-0 z-20">PDF Name</div>
            <div className="font-bold border-r border-b py-3 bg-white sticky top-0 z-20">Pages</div>
            {pdfInfo.map((pdf, index) => (
                <React.Fragment key={index}>
                    <div  onClick={() => handleClick(pdf.name)} className="cursor-pointer hover:text-blue-800 border-r border-b ">{pdf.name}</div>
                    <div className=" border-r border-b">{pdf.pages}</div>
                    
                </React.Fragment>
            ))}
        </div> */}

<div className="grid grid-cols-3 border overflow-y-scroll max-h-96">
    <div className="col-span-2 font-bold border-r border-b py-3 bg-white sticky top-0 z-20">
      PDF Name
    </div>
    <div className="col-span-1 font-bold border-r border-b py-3 bg-white sticky top-0 z-20">
      Pages
    </div>
    {pdfInfo.length === 0 ? (
      // Conditionally show loading or No PDF
      <div className="col-span-3 p-5">
        {loading ? (
          // Loading spinner for this section
          <div className="flex space-x-2 justify-center items-center">
            <span className="sr-only">Loading...</span>
            <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
            <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
            <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
          </div>
        ) : (
          "No PDF"
        )}
      </div>
    ) : (
      // PDF list
      pdfInfo.map((pdf, index) => (
        <React.Fragment key={index}>
          <div
            onClick={() => handleClick(pdf.name)}
            className="col-span-2 cursor-pointer hover:text-red-700 border-r border-b py-3"
          >
            {pdf.name}
          </div>
          <div className="col-span-1 border-r border-b py-3">
            {pdf.pages}
          </div>
        </React.Fragment>
      ))
    )}
  </div>
              </div>

              {/* <button onClick={handleRefresh} className="w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600">
      Clear
    </button> */}
            </div>
          </div>

          {/* Right Section: Extracted PDF Response */}
          <div className="p-2 bg-gray-50 border ">

          {/* {showToast && (
      <div id="toast-success" class="fixed bottom-5 right-5 flex items-center w-full max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800" role="alert">
        <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-green-500 bg-green-100 rounded-lg dark:bg-green-800 dark:text-green-200">
          <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
          </svg>
          <span class="sr-only">Check icon</span>
        </div>
        <div class="ms-3 text-sm font-normal">Item moved successfully.</div>
        <button type="button" class="ms-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700" data-dismiss-target="#toast-success" aria-label="Close">
          <span class="sr-only">Close</span>
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
        </button>
      </div>
    )} */}
            <form onSubmit={sendFilesToBackend}>
              <div className="flex space-x-2">
                 {/* <input
                                    type="text"
                                 value={employeecode}
                                     onChange={handleEmployeeCodeChange}
                                    placeholder="Enter employee code"
                                    className=" w-96 p-1 block  text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
                                />  */}

<div className="relative "  ref={gridRef}>
            <input
                type="search"
                value={selectedEmployee}
                onFocus={() => setIsGridOpen(true)}
                onChange={handleEmployeeCodeChanges}
                placeholder="Enter employee code"
                className="placeholder-red-700 w-96 p-2 block text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
            />

            {/* {employeecode && (
                <div className="absolute bg-white border border-gray-300 rounded-md shadow-lg mt-1 w-96 max-h-60 overflow-auto">
                    {filteredEmployees.length > 0 ? (
                        <div className="grid grid-cols-3 gap-2 p-2">
                            {filteredEmployees.map((employee) => (
                                <div key={employee.code} className="p-2 border-b">
                                    <div>{employee.code}</div>
                                    <div>{employee.name}</div>
                                    <div>{employee.department}</div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="p-2 text-gray-500">No data found</div>
                    )}
                </div>
            )} */}
            {isGridOpen && employeecode && (
  <div className="absolute bg-white border border-gray-300 rounded-md shadow-lg mt-1 w-96 max-h-60 overflow-auto cursor-pointer z-50">
    {filteredEmployees.length > 0 ? (
      <div className="grid grid-cols-3">
          <div className="font-bold p-2 border-b">Employee Code</div>
      <div className="font-bold p-2 border-b">Employee Name</div>
      <div className="font-bold p-2 border-b">KHUID</div>
        {filteredEmployees.map((employee) => (
          <React.Fragment key={employee.EmployeeID}>
            <div
              className="p-2 border-b cursor-pointer"
              onClick={() => handleEmployeeClick(employee.EmployeeCode, employee.EmployeeName, employee.KHUID)}  // Pass EmployeeCode to the function
            >
              {employee.EmployeeCode}
            </div>
            <div className="p-2 border-b"  onClick={() => handleEmployeeClick(employee.EmployeeCode, employee.EmployeeName, employee.KHUID)} >{employee.EmployeeName}</div>
            <div className="p-2 border-b "   onClick={() => handleEmployeeClick(employee.EmployeeCode, employee.EmployeeName, employee.KHUID)} >{employee.KHUID}</div>
          </React.Fragment>
        ))}
      </div>
    ) : (
      <p>No employees found</p>
    )}
  </div>
)}

        </div>

                {/* <label htmlFor="employeeSelect" className="mb-2 text-lg font-semibold">
        Select Employee Code:
      </label>  */}
                {/* <select
                  id="employeeSelect"
                  type="number"
                  onClick={handleEmployeeCodeChange}
                  className="w-96 p-1 block  text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
                >
                  <option value="">Select an Employee Code</option>
                  {employees.map((employee) => (
                    <option
                      key={employee.EmployeeID}
                      value={employee.EmployeeCode}
                    >
                      {employee.EmployeeCode}
                    </option>
                  ))}
                </select> */}

                {/* <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Category:</label>
            <select
                value={selectedName}
                onChange={(e) => setSelectedName(e.target.value)}
                className="p-2 mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
            >
                <option value="" disabled>Select a name</option>
                {names.map((name, index) => (
                    <option key={index} value={name}>
                        {name}
                    </option>
                ))}
            </select>
        </div> */}

                {/* <button 
                            
                                type="submit" 
                                className="px-5 bg-black  text-white  rounded-full shadow hover:bg-slate-700 "
                            >
                                Save
                            </button> */}

                <button   class="overflow-hidden relative w-32  h-9 bg-black text-white border-none rounded-md text-xl font-bold cursor-pointer relative z-10 group">
                  Save
                  <span class="absolute w-36 h-32 -top-9 -left-2 bg-white rotate-12 transform scale-x-0 group-hover:scale-x-100 transition-transform group-hover:duration-500 duration-1000 origin-left"></span>
                  <span class="absolute w-36 h-32 -top-8 -left-2 bg-indigo-400 rotate-12 transform scale-x-0 group-hover:scale-x-100 transition-transform group-hover:duration-700 duration-700 origin-left"></span>
                  <span class="absolute w-36 h-32 -top-8 -left-2 bg-indigo-600 rotate-12 transform scale-x-0 group-hover:scale-x-50 transition-transform group-hover:duration-1000 duration-500 origin-left"></span>
                  <span class="group-hover:opacity-100 group-hover:duration-1000 duration-100 opacity-0 absolute top-1.3 left-7 z-10">
                    Save!
                  </span>
                </button> 

                {/* <button
  disabled={file} // Button is disabled when there is no file
  className={`overflow-hidden relative w-32 h-8 text-white border-none rounded-md text-xl font-bold cursor-pointer relative z-10 group
    ${file ? 'bg-gray-400 cursor-not-allowed' : 'bg-black cursor-pointer'}`} // Gray background and disabled cursor when no file is selected, black and pointer when file is selected
>
  Save
  {!file && ( // Show animations only when a file is selected
    <>
      <span className="absolute w-36 h-32 -top-9 -left-2 bg-white rotate-12 transform scale-x-0 group-hover:scale-x-100 transition-transform group-hover:duration-500 duration-1000 origin-left"></span>
      <span className="absolute w-36 h-32 -top-8 -left-2 bg-indigo-400 rotate-12 transform scale-x-0 group-hover:scale-x-100 transition-transform group-hover:duration-700 duration-700 origin-left"></span>
      <span className="absolute w-36 h-32 -top-8 -left-2 bg-indigo-600 rotate-12 transform scale-x-0 group-hover:scale-x-50 transition-transform group-hover:duration-1000 duration-500 origin-left"></span>
      <span className="group-hover:opacity-100 group-hover:duration-1000 duration-100 opacity-0 absolute top-1.3 left-7 z-10">
        Save!
      </span>
    </>
  )}
</button> */}
              </div>
            </form>
            <div className="text-center ">
              <h3 className="text-lg font-medium text-gray-700">
                Extracted PDF
              </h3>
            </div>
            <h4>{namess}.pdf</h4>

            {/* Display any extracted PDF data or response here */}
            {/* {loading ? (
              <div className=" flex space-x-2 justify-center items-center bg-white h-screen dark:invert">
                <span className="sr-only">Loading...</span>
                <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
              </div>
            ) :  */}
            {newpdf ? (
              <iframe
                id="pdf-iframe"
                ref={iframeRef}
                src={`${newpdf}#page=1&zoom=fit`}
                title="PDF Preview"
                className="w-full h-[680px] border border-gray-300 shadow-md fixed sticky"
                frameBorder="0"
                // style={{ width: '100%', height: '100%', border: 'none' }}
              />
            ) : (
              <p className="text-center text-gray-500">No PDF uploaded yet</p>
            )}
          </div>

        </div>
      </div>
    </div>
    </>
  );
};

export default Temp2;
